export function isProgramSiteContextError(error) {
    return [
        'INVALID_SITE_CONTEXT',
        'SITE_NOT_FOUND',
        'SITE_ACCESS_FORBIDDEN',
        'ABX_SITE_FORBIDDEN',
    ].includes(error?.code);
}

export async function refreshProgramSiteAuthorization({
    siteStore,
    userStore,
}) {
    await userStore.refresh();
    const sites = await siteStore.fetchSites();
    if (siteStore.fetchError) throw siteStore.fetchError;
    siteStore.normalizeGlobalSiteAuthorization();
    return sites;
}

export async function recoverProgramSiteContext(
    { siteStore, programStore, refreshAuthorization },
    error
) {
    if (!isProgramSiteContextError(error)) return false;

    siteStore.setGlobalSiteId(null);
    programStore.setSiteContext(null);
    await refreshAuthorization();
    return true;
}

export function programSiteDisplayName(siteId, sites = []) {
    if (siteId === null || siteId === undefined || siteId === '') return '';

    const site = sites.find((candidate) => {
        const candidateId =
            typeof candidate === 'object' ? candidate?.id : candidate;
        return String(candidateId) === String(siteId);
    });

    return typeof site === 'object' && site?.name
        ? site.name
        : `Site ${siteId}`;
}
